import { spawn } from "node:child_process";

/**
 * Opens a local file in the OS default browser/handler, spawned detached so it does
 * not block or hang the caller. Best-effort: failures are swallowed (nothing sensible
 * to do about a missing `xdg-open`/`open`/`start` from a command handler).
 */
export function openInBrowser(filePath: string): void {
  const { command, args } = resolveOpenCommand(filePath);

  try {
    const child = spawn(command, args, { detached: true, stdio: "ignore" });
    child.on("error", () => {
      // Best-effort: nothing sensible to do if the OS opener is missing.
    });
    child.unref();
  } catch {
    // Best-effort: swallow spawn failures.
  }
}

function resolveOpenCommand(filePath: string): { command: string; args: string[] } {
  if (process.platform === "win32") {
    // "start" is a cmd.exe builtin; the empty string is the (required) window title arg.
    return { command: "cmd", args: ["/c", "start", "", filePath] };
  }

  if (process.platform === "darwin") {
    return { command: "open", args: [filePath] };
  }

  return { command: "xdg-open", args: [filePath] };
}
